Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMapData = updateMapData;
exports.setMapData = setMapData;
exports.setMarkerOnTop = setMarkerOnTop;
exports.setOpenMarkers = setOpenMarkers;

var _constants = require('../constants');

var _query = require('./query');

function updateMapData(componentId, query, persistMapQuery) {
  return {
    type: _constants.SET_MAP_DATA,
    componentId: componentId,
    query: query,
    persistMapQuery: persistMapQuery
  };
}

function setMapData(componentId, query, persistMapQuery, forceExecute) {
  return function (dispatch) {
    dispatch(updateMapData(componentId, query, persistMapQuery));

    if (forceExecute) {
      var executeWatchList = false;
      var mustExecuteMapQuery = true;
      dispatch((0, _query.executeQuery)(componentId, executeWatchList, mustExecuteMapQuery));
    }
  };
}

function setMarkerOnTop(markerId) {
  return {
    type: _constants.SET_MAP_ON_TOP_MARKER,
    markerId: markerId
  };
}

function setOpenMarkers(openMarkers) {
  return {
    type: _constants.SET_MAP_OPEN_MARKERS,
    openMarkers: openMarkers
  };
}